import React from 'react';
import cn from '@/utils/cn';
import { iconVariant, TIconColor } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface SquaresPlusProps extends IconProps {
  color?: TIconColor;
}

const SquaresPlus = ({ size, variant, className, color = 'white' }: SquaresPlusProps) => (
  <svg
    className={cn(iconVariant({ size, variant, iconColor: color, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16">
    <path
      d="M4 2C2.89543 2 2 2.89543 2 4V5.5C2 6.60457 2.89543 7.5 4 7.5H5.5C6.60457 7.5 7.5 6.60457 7.5 5.5V4C7.5 2.89543 6.60457 2 5.5 2H4Z"
      fill="currentColor"
    />
    <path
      d="M10.5 2C9.39543 2 8.5 2.89543 8.5 4V5.5C8.5 6.60457 9.39543 7.5 10.5 7.5H12C13.1046 7.5 14 6.60457 14 5.5V4C14 2.89543 13.1046 2 12 2H10.5Z"
      fill="currentColor"
    />
    <path
      d="M4 8.5C2.89543 8.5 2 9.39543 2 10.5V12C2 13.1046 2.89543 14 4 14H5.5C6.60457 14 7.5 13.1046 7.5 12V10.5C7.5 9.39543 6.60457 8.5 5.5 8.5H4Z"
      fill="currentColor"
    />
    <path
      d="M11.75 9C11.75 8.72386 11.5261 8.5 11.25 8.5C10.9739 8.5 10.75 8.72386 10.75 9V10.75H9C8.72386 10.75 8.5 10.9739 8.5 11.25C8.5 11.5261 8.72386 11.75 9 11.75H10.75V13.5C10.75 13.7761 10.9739 14 11.25 14C11.5261 14 11.75 13.7761 11.75 13.5V11.75H13.5C13.7761 11.75 14 11.5261 14 11.25C14 10.9739 13.7761 10.75 13.5 10.75H11.75V9Z"
      fill="currentColor"
    />
  </svg>
);

export default SquaresPlus;
